// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dot-color_wrapper__2JK0j"};